/**
 * Shared client-side CSV helpers (same escape/download pattern as Linehaul LMI).
 */

export const escapeCsvValue = (value: string | number | null | undefined): string => {
  const str = value == null ? "" : String(value);
  if (str.includes(",") || str.includes("\n") || str.includes('"')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

export const downloadCsvFile = (
  filename: string,
  headers: string[],
  rows: (string | number | null | undefined)[][]
): void => {
  const csvContent = [
    headers.map(escapeCsvValue).join(","),
    ...rows.map((row) => row.map(escapeCsvValue).join(",")),
  ].join("\n");

  // UTF-8 BOM helps Excel detect encoding (avoids mojibake on special characters).
  const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
